    
        $(function () {
            var Accordion = function (el, multiple) {
                this.el = el || {};
                this.multiple = multiple || false;
                var links = this.el.find('.xzzx-b-l-b-t');
                links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown);
            };
            Accordion.prototype.dropdown = function (e) {
                var $el = e.data.el;
                $this = $(this), $next = $this.next();
                $next.slideToggle();
                $this.parent().toggleClass('active');
            };
            var accordion = new Accordion($('.xzzx-b-l-b ul'), false);

            // 初始化显示
            $(".asjkdhki").show();
            $(".xzzx-b-r:eq(0)").show();
            $(".xzzx-b-r:eq(0)").siblings().hide();
            $("#inside_page").hide();

            // 2026年产品点击事件
            $(".products_2026 a").on("click", function () {
                var index = $(this).index();
                $(".asjkdhki").show();
                $(".software2026_download").find(".xzzx-b-r").eq(index).show().siblings().hide();
                $(".software2026_download").siblings().find(".xzzx-b-r").hide();
                $("#inside_page").hide();
            });

            // 2023-2025产品点击事件
            $(".products_2023 a").on("click", function () {
                var index = $(this).index();
                $(".asjkdhki").show();
                $(".software2023_download").find(".xzzx-b-r").eq(index).show().siblings().hide();
                $(".software2023_download").siblings().find(".xzzx-b-r").hide();
                $("#inside_page").hide();
            });

            // 2022产品点击事件
            $(".products_2022 a").on("click", function () {
                var index = $(this).index();
                $(".asjkdhki").show();
                $(".software2022_download").find(".xzzx-b-r").eq(index).show().siblings().hide();
                $(".software2022_download").siblings().find(".xzzx-b-r").hide();
                $("#inside_page").hide();
            });

            // 2021产品点击事件
            $(".prevou_ones a").on("click", function () {
                var index = $(this).index();
                $(".asjkdhki").show();
                $(".pre_one_secs").find(".xzzx-b-r").eq(index).show().siblings().hide();
                $(".pre_one_secs").siblings().find(".xzzx-b-r").hide();
                $("#inside_page").hide();
            });

            // previous产品点击事件
            $(".receones a").on("click", function () {
                var index = $(this).index();
                $(".asjkdhki").show();
                $(".one_secs").find(".xzzx-b-r").eq(index).show().siblings().hide();
                $(".one_secs").siblings().find(".xzzx-b-r").hide();
                $("#inside_page").hide();
            });

            // 更新工具点击事件
            $(".xzzx-b-r2 #update_tool").on("click", function () {
                $("#asjkdhki").hide();
                $("#inside_page").show();
            });

            // 选中样式处理
            $(".products_2026 a:nth-child(1)").addClass('selected');

            // 2026年选中样式
            $(".products_2026 a").on("click", function () {
                $(this).siblings(".products_2026 a").removeClass('selected');
                $(this).parent().parent().siblings().find(".xzzx-b-l-b-b a").removeClass('selected');
                $(this).addClass('selected');
            });

            // 2023-2025选中样式
            $(".products_2023 a").on("click", function () {
                $(this).siblings(".products_2023 a").removeClass('selected');
                $(this).parent().parent().siblings().find(".xzzx-b-l-b-b a").removeClass('selected');
                $(this).addClass('selected');
            });

            // 2022选中样式
            $(".products_2022 a").on("click", function () {
                $(this).siblings(".products_2022 a").removeClass('selected');
                $(this).parent().parent().siblings().find(".xzzx-b-l-b-b a").removeClass('selected');
                $(this).addClass('selected');
            });

            // 2021选中样式
            $(".prevou_ones a").on("click", function () {
                $(this).siblings(".prevou_ones a").removeClass('selected');
                $(this).parent().parent().siblings().find(".xzzx-b-l-b-b a").removeClass('selected');
                $(this).addClass('selected');
            });

            // previous选中样式
            $(".receones a").on("click", function () {
                $(this).siblings(".receones a").removeClass('selected');
                $(this).parent().parent().siblings().find(".xzzx-b-l-b-b a").removeClass('selected');
                $(this).addClass('selected');
            });

            // 其他年份选中样式（保留原有代码）
            $(".recetwos a").on("click", function () {
                $(this).siblings(".recetwos a").removeClass('selected');
                $(this).parent().parent().siblings().find(".xzzx-b-l-b-b a").removeClass('selected');
                $(this).addClass('selected');
            });
            $(".recethrees a").on("click", function () {
                $(this).siblings(".recethrees a").removeClass('selected');
                $(this).parent().parent().siblings().find(".xzzx-b-l-b-b a").removeClass('selected');
                $(this).addClass('selected');
            });
            $(".recefours a").on("click", function () {
                $(this).siblings(".recefours a").removeClass('selected');
                $(this).parent().parent().siblings().find(".xzzx-b-l-b-b a").removeClass('selected');
                $(this).addClass('selected');
            });

            // 原有折叠菜单代码
            $("ul.kj li > div.t").click(function () {
                var arrow = $(this).find("span.arrow");
                if (arrow.hasClass("up")) {
                    arrow.removeClass("up");
                    arrow.addClass("down");
                } else if (arrow.hasClass("down")) {
                    arrow.removeClass("down");
                    arrow.addClass("up");
                }
                $(this).parent().siblings().each(function (index, el) {
                    $(el).find("ul.menu").slideUp();
                    $(el).find(".arrow").removeClass("up").addClass("down");
                });
                $(this).parent().find("ul.menu").slideToggle();
            });

            $("ul.kj li .menu li a").click(function () {
                $(this).parent().siblings().each(function (index, el) {
                    $(el).find(".sj_3ji").slideUp();
                });
                $(this).siblings('.sj_3ji').slideToggle();
            });
        });
  